import { AxiosError } from 'axios';
import { UiResponse } from '../CommonInterfaces';
import CookieApi from './CookieApi';

const ErrorUtil = {
  pushErrorToTeliaRum(error: Error, message?: string): string {
    if ((error as AxiosError)?.config) {
      const e = error as AxiosError;
      (error as AxiosError).stack = `${e?.message}, ${e?.config?.method}:${e?.config?.url} \n ${e.stack}`;
      e.message = (e.response?.data as UiResponse)?.notice?.message || e.message;
    }
    return window.TeliaRum?.sendError(error, message);
  },

  pushErrorToTeliaRumAndLog(error: Error, message?: string): void {
    const errorAsAxiosError: AxiosError = error as AxiosError;
    /**
     * bugfix for axios.cancel when navigating between apps (e.g login in tweb redirects to selfservice) in safari,
     * may try to remove when axios is updated/fixed (current v0.27.2) or replaced with other dependency
     */
    const mightBeSafariBrowserCancelError: boolean =
      navigator.vendor?.toLowerCase().includes('apple') && errorAsAxiosError?.code === 'ERR_NETWORK' && errorAsAxiosError?.message?.includes('Network Error');
    if (!mightBeSafariBrowserCancelError) {
      this.pushErrorToTeliaRum(error, message);
      console.error(error);
    }
  },

  pushErrorToTeliaRumAndLogWithLocation(errorMessage: string) {
    const error = new Error(errorMessage);
    error.stack = `page: ${window.location.pathname}`;
    ErrorUtil.pushErrorToTeliaRumAndLog(error);
  },

  pushErrorToTeliaRumAndGetTransaction(error: Error, message?: string): string {
    const otelReference: string = this.pushErrorToTeliaRum(error, message);
    return `tx:${otelReference}:ut:${this.getTeliaRumUserTrackerCookie()}`;
  },

  getTeliaRumUserTrackerCookie(): string | null {
    return CookieApi.getCookieValue('rum_session_id');
  }
};

export default ErrorUtil;
